import styled from 'styled-components';
import { BOX_SHADOW, DARKER, PRIMARY, SECONDARY } from '../../const/colors';
import { mobile_medium, mobile_normal, mobile_title } from '../../const/fonts';

export const Container = styled.div`
	background-color: ${SECONDARY};
	border: 1px solid ${PRIMARY};
	text-align: end;
	position: relative;
	width: 600px;

	@media screen and (max-width: 2000px) {
		width: 500px;
	}
	@media screen and (max-width: 768px) {
		width: 100vw;
		height: 100vh;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding-top: 4rem;
		border: none;
		overflow: hidden;
	}
`;
export const ButtonClose = styled.button`
	border: none;
	background-color: #fff;
	color: ${SECONDARY};
	padding: 0.5rem;
	cursor: pointer;
	transition: background-color 0.3s ease-in-out;
	svg {
		font-size: 2.5rem;
	}
	&:hover {
		background-color: #93291E;
		svg {
			color: #fff;
		}
	}

	@media screen and (max-width: 1600px) {
		padding: 0.1rem;
	}

	@media screen and (max-width: 768px) {
		display: inline-block;
		position: absolute;
		top: 5rem;
		right: 10px;
		z-index:1;
	}
`;
export const Form = styled.form`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 0 4rem;
	position: relative;
	> div {
		position: relative;
		width: 70%;
	}
	> img {
		width: 70px;
		margin-bottom: 1rem;
	}
	> h3 {
		color: #fff;
		font-size: 1.2rem;
		margin-bottom: 1rem;
	}

	p.error {
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.3s ease;
		color: #fff;
		font-size: 10px;
		text-align: center;

		svg {
			width: 16px;
			margin-right: 5px;
			color: #C21010;
		}
	}

	@media screen and (max-width: 2000px) {
		> img  {
			width: 60px;
		}
	}

	@media screen and (max-width: 1600px) {
		> img  {
			width: 50px;
		}
		> h3 {
			margin-bottom: 0;
		}
	}

	@media screen and (max-width: 768px) {
		padding: 0 2rem;
		padding-top: 10%;
    border-top: 10px solid ${PRIMARY};
		> div {
			width: 80%;
		}
		> img {
			width: 40px;
		}
		> h3 {
			font-size: ${mobile_title};
		}
	}
	@media screen and (max-width: 480px) {
		padding-top: 8%;
		> div {
			width: 90%;
		}
	}
`;
export const InputItem = styled.div`
	position: relative;
	width: 100%;
	> input {
		border: 1px solid ${PRIMARY};
		outline: none;
		background-color: transparent;
		color: #fff;
		padding: 0.7rem 1rem;
		font-size: 0.9rem;
		width: 100%;
		margin-top: 1.5rem;
	}
	> input.error {
		border-color: red;
	}
	input:focus ~ label {
		top: 0.9rem;
		background-color: ${SECONDARY};
		opacity: 1;
	}
	> label {
		position: absolute;
		top: 2.1rem;
		left: 0; 
  	right: 0; 
 	  margin-left: auto; 
  	margin-right: auto; 
		width: fit-content;
		text-align: center;
		pointer-events: none;
		transition: all .3s;
		padding: 0 0.2rem;
		color: #fff;
		opacity: ${props => props.value !== '' ? 0 : 1};
		font-size: 0.9rem;
		font-weight: bold;
	}

	@media screen and (max-width: 768px) {

		> label {
			font-size: ${mobile_normal};
		}
	}
	&:hover {
		input {
			border-color: #fff;
		}
	}
`;
export const ButtonLogin = styled.button`
	width: 100%;
	font-size: 1rem;
  font-weight: bold;
	border: none;
  background-color: ${PRIMARY};
  color: ${SECONDARY};
  box-shadow: ${BOX_SHADOW};
  padding: 0.7rem;
	margin-top: 1.5rem;
  cursor: pointer;
  transition: all .3s ease-in-out;
  :disabled {
		cursor:progress;
	}
  &:hover:not(:disabled){
    background-color: #fff;
  }

	@media screen and (max-width: 2000px) {
		font-size: 0.9rem;
	}
	@media screen and (max-width: 1600px) {
		font-size: 0.8rem;
	}
	@media screen and (max-width: 768px) {
		font-size: ${mobile_normal};
	}
`;
export const ForgotPassword = styled.div`
	font-size: 1rem;
	font-weight: bold;
	text-align: center;
	color: ${PRIMARY};
	margin: 1.5rem 0;
	cursor: pointer;

	transition: color 0.3s ease;
	&:hover {
		color: #ccc;
	}

	@media screen and (max-width: 2000px) {
		font-size: ${mobile_medium};
	}
`;
export const RegisterOption = styled.div`
	background-color: ${DARKER};
	width: 100%;
	padding: 2rem 4rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	> p {
		color: #fff;
		font-size: 1rem;
		font-weight: bold;
		text-align: center;
	}

	@media screen and (max-width: 2000px) {
		> p {
			font-size: ${mobile_medium};
		}
	}
	@media screen and (max-width: 1600px) {
		padding: 1rem 4rem;
	}
`;
export const ButtonRegister = styled(ButtonLogin)`
	width: 70%;
	background-color: transparent;
	border: 1px solid ${PRIMARY};
	color: ${PRIMARY};
	box-shadow: none;

	&:hover{
		color: ${SECONDARY};
  }

	@media screen and (max-width: 768px) {
		width:90%;
	}
	@media screen and (max-width: 480px) {
		width: 100%;
	}
`;

export const ButtonCancel = styled(ButtonRegister)`
	background-color: #C21010;
  color: #fff;
	border: none;
`;

export const ContainerModal = styled.div`
	background-color: ${SECONDARY};
	border: 1px solid ${PRIMARY};
	text-align: end;
`;
